// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 検索インデックスの作成を待つため、通常より長めに待つ(ms)
const TENANT_CREATE_TIMEOUT = 120 * 1000;

// 運営ツール: テナント作成
const AdminOpsTenantCreateApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_tenant_create";

    const ExecAdminOpsTenantCreateApi = async (params) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: params, timeout: TENANT_CREATE_TIMEOUT });
    };

    return ExecAdminOpsTenantCreateApi;
};

export default AdminOpsTenantCreateApi;
